import { useMutation } from '@tanstack/react-query';
import doRequest from './doRequest';
import { AUTH_REFRESH } from '../services/URLs';
import StorageService, { RefreshTokenResponse } from '../services/storageService';

export const useRefreshToken = () => {
  return useMutation({
    mutationKey: ['REFRESH_TOKEN'],
    mutationFn: async () => {
      const refreshToken = StorageService.getRefreshToken();
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const response = await doRequest({
        method: 'post',
        url: AUTH_REFRESH,
        payload: { refreshToken },
        config: {
          headers: {
            Authorization: `Bearer ${refreshToken}`
          }
        },
        completeResponse: false,
      });

      if (response?.accessToken) {
        return response as RefreshTokenResponse;
      }
      throw new Error('Failed to refresh token');
    },
  });
}; 